export default __webpack_public_path__ + "static/media/2.25c6fe27.png";